import { render, staticRenderFns } from "./PutOnTest.vue?vue&type=template&id=3588a691&scoped=true"
import script from "./PutOnTest.vue?vue&type=script&lang=ts"
export * from "./PutOnTest.vue?vue&type=script&lang=ts"
import style0 from "./PutOnTest.vue?vue&type=style&index=0&id=3588a691&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588a691",
  null
  
)

export default component.exports